import { defineMessages } from '@transcend-io/internationalization';

export const selectTcfPurposeMessages = defineMessages(
  'admin-dashboard.ConsentManager.Tcf.TcfStacks.components.SelectTcfPurpose.selectTcfPurpose',
  {
    selectPlaceholder: { defaultMessage: 'Select TCF purposes...' },
    label: { defaultMessage: 'TCF Purposes' },
  },
);
